import { useState } from "react";
import { InvoiceRow } from "../../components/modal/CreateInvoice";

export function useCreateInvoice() {
  const [rows, setRows] = useState<InvoiceRow[]>([]);
  const [totals, setTotals] = useState({
    totalAmount: 0,
    totalGst: 0,
    grandTotal: 0,
  });

  const addRow = () => {
    setRows((prev) => [
      ...prev,
      {
        id: (prev.length + 1).toString(),
        itemName: "",
        amount: "",
        discount: "",
        discountType: "₹",
        discountRemark: "",
        gst: "0%",
      },
    ]);
  };

  const calculateTotals = (rows: InvoiceRow[]) => {
    let totalAmount = 0;
    let totalGst = 0;

    rows.forEach((row) => {
      const amount = parseFloat(row.amount || "0");
      const discount = parseFloat(row.discount || "0");
      const gstPercentage = parseFloat(row.gst.replace("%", "") || "0");

      let discountedAmount = amount;

      if (row.discountType === "%" && discount > 0) {
        discountedAmount = amount - (amount * discount) / 100;
      } else if (row.discountType === "₹" && discount > 0) {
        discountedAmount = amount - discount;
      }

      const gstAmount = discountedAmount * (gstPercentage / 100);

      totalAmount += discountedAmount;
      totalGst += gstAmount;
    });

    setTotals({
      totalAmount,
      totalGst,
      grandTotal: totalAmount + totalGst,
    });
  };

  const updateValue = (
    index: number,
    field: keyof InvoiceRow,
    value: string
  ) => {
    setRows((prev) => {
      const updated = [...prev];
      updated[index] = { ...updated[index], [field]: value };
      calculateTotals(updated);
      return updated;
    });
  };

  return {
    rows,
    totals,
    addRow,
    updateValue,
    setRows,
    calculateTotals,
  };
}
